import React from "react";

export interface IOrderImageProps {
  orderLine: {
    qty: number;
    imageUrl: string;
    itemDescription: string;
  };
  defaultSrc: string;
}

function OrderImage(props: IOrderImageProps) {
  return (
    <span className="position-relative d-inline-block">
      {props.orderLine.qty > 1 && (
        <span className="order-image-badge">
          <span>{props.orderLine.qty}</span>
        </span>
      )}
      <img
        src={
          props.orderLine.imageUrl ? props.orderLine.imageUrl : props.defaultSrc
        }
        alt={props.orderLine.itemDescription}
      />
    </span>
  );
}

export default OrderImage;
